module.exports = __webpack_public_path__ + "static/media/Abishek-Sharma.1a210f04.jpg";